export default function Loading() {
    return (
        <div className="loading-overlay">
            <div className="popcorn-animation">
            {/* Pochoclo principal que se agita */}
            <svg className="popcorn-main" width="160" height="200" viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 60 L25 90 L55 90 L60 60 Z" fill="#FFE5B4" stroke="#FFD700" strokeWidth="2"/>
                <circle cx="25" cy="45" r="8" fill="#FFF8DC"/>
                <circle cx="40" cy="40" r="10" fill="#FFF8DC"/>
                <circle cx="55" cy="45" r="8" fill="#FFF8DC"/>
                <circle cx="32" cy="50" r="7" fill="#FFF8DC"/>
                <circle cx="48" cy="50" r="7" fill="#FFF8DC"/>
                <circle cx="40" cy="55" r="6" fill="#FFF8DC"/>
            </svg>
            
            {/* Pochoclos que explotan */}
            <svg className="popcorn-pop popcorn-1" width="50" height="50" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="6" fill="#FFF8DC"/>
                <circle cx="12" cy="12" r="4" fill="#FFF8DC"/>
                <circle cx="18" cy="12" r="4" fill="#FFF8DC"/>
            </svg>
            
            <svg className="popcorn-pop popcorn-2" width="50" height="50" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="6" fill="#FFF8DC"/>
                <circle cx="12" cy="12" r="4" fill="#FFF8DC"/>
                <circle cx="18" cy="12" r="4" fill="#FFF8DC"/>
            </svg>
            
            <svg className="popcorn-pop popcorn-3" width="50" height="50" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="6" fill="#FFF8DC"/>
                <circle cx="12" cy="12" r="4" fill="#FFF8DC"/>
                <circle cx="18" cy="12" r="4" fill="#FFF8DC"/>
            </svg>
            
            <svg className="popcorn-pop popcorn-4" width="50" height="50" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="6" fill="#FFF8DC"/>
                <circle cx="12" cy="12" r="4" fill="#FFF8DC"/>
                <circle cx="18" cy="12" r="4" fill="#FFF8DC"/>
            </svg>
            
            <svg className="popcorn-pop popcorn-5" width="50" height="50" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="6" fill="#FFF8DC"/>
                <circle cx="12" cy="12" r="4" fill="#FFF8DC"/>
                <circle cx="18" cy="12" r="4" fill="#FFF8DC"/>
            </svg>
            
            <svg className="popcorn-pop popcorn-6" width="50" height="50" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="6" fill="#FFF8DC"/>
                <circle cx="12" cy="12" r="4" fill="#FFF8DC"/>
                <circle cx="18" cy="12" r="4" fill="#FFF8DC"/>
            </svg>
            </div>
        </div>
    );
}
